import { FormattedMessage, useIntl } from 'react-intl';

import * as S from './styles';
import { Band, Inner, SectionHead } from '../ui/Section';
import Reveal from '../ui/Reveal';
import Img1 from '../../imgs/1.jpeg';
import Img2 from '../../imgs/2.jpeg';
import Img3 from '../../imgs/3.jpeg';
import Img4 from '../../imgs/4.jpeg';

const span = { span: (chunks) => <span>{chunks}</span> };

// `shape` is a translation key when the name differs by language; Almond and
// Stiletto are the same word in both, so they're literals.
const SHAPES = [
  { img: Img1, id: 'photos.square' },
  { img: Img2, id: 'photos.ballerina' },
  { img: Img3, name: 'Almond' },
  { img: Img4, name: 'Stiletto' },
];

function Photos() {
  const intl = useIntl();

  return (
    <Band $tone="dark">
      <Inner>
        <SectionHead tone="dark" eyebrow={<FormattedMessage id="shapes.eyebrow" />}>
          <FormattedMessage id="photos.title" values={span} />
        </SectionHead>

        <S.Grid>
          {SHAPES.map((shape, i) => {
            const name = shape.id ? intl.formatMessage({ id: shape.id }) : shape.name;

            return (
              <Reveal key={name} as="li" delay={i * 90}>
                <figure>
                  <div className="frame">
                    <img
                      src={shape.img}
                      alt={intl.formatMessage({ id: 'photos.imageAlt' }, { shape: name })}
                      loading="lazy"
                    />
                  </div>
                  <figcaption>{name}</figcaption>
                </figure>
              </Reveal>
            );
          })}
        </S.Grid>
      </Inner>
    </Band>
  );
}

export default Photos;
